module.exports = __webpack_public_path__ + "static/media/apple_badge.ee04d4e8.svg";